module.exports = __webpack_public_path__ + "static/echo-burning-7e6385bb7a815e88091a9659385f799e.jpg";